import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import React from 'react';

interface WarningActivateRequestProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleActivateRequest: () => void;
}

const WarningActivateRequest: React.FC<WarningActivateRequestProps> = ({
  open,
  setOpen,
  handleActivateRequest,
}) => {
  const handleConfirm = async () => {
    handleActivateRequest();
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Activar solicitud</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Alert severity="info" variant="outlined">
            ¿Confirmas que deseas activar la solicitud? Se pasará el estado de
            la solicitud a ACTIVA. Las facturas de la solicitud ingresarán a la
            cartera.
          </Alert>
          <Alert severity="warning" variant="outlined">
            Recuerda que esta acción NO ejecuta los pagos de la nómina. SÓLO se
            activará la solicitud.
          </Alert>
        </Stack>
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={() => setOpen(false)}>
          Cancelar
        </CustomButton>
        <CustomButton color="success" onClick={() => void handleConfirm()}>
          Activar solicitud
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default WarningActivateRequest;
